/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Plan_Pro_AudienceInputs */



/**
* | output |
* | --- |
* | "For individuals and teams" |
*
* @param {Signup_Plan_Pro_AudienceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_plan_pro_audience = /** @type {((inputs?: Signup_Plan_Pro_AudienceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Plan_Pro_AudienceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("For individuals and teams")
	if (locale === "de") return /** @type {LocalizedString} */ ("For individuals and teams")
	if (locale === "it") return /** @type {LocalizedString} */ ("For individuals and teams")
	if (locale === "ru") return /** @type {LocalizedString} */ ("For individuals and teams")
	if (locale === "es") return /** @type {LocalizedString} */ ("For individuals and teams")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("For individuals and teams")
	if (locale === "ja") return /** @type {LocalizedString} */ ("For individuals and teams")
	if (locale === "hi") return /** @type {LocalizedString} */ ("For individuals and teams")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("For individuals and teams")
	return /** @type {LocalizedString} */ ("For individuals and teams")
});